import type { FilterWidget, SmartViewWidget, Widgets } from "../../../../api/types/dashboardsTypes";
import { WidgetType } from "../../../../api/types/dashboardsTypes";
import type { TileObject, TileObjectFilter, TileObjectSmartView } from "./TileObject";

export const isTileObjectSmartView = (tile: TileObject): tile is TileObjectSmartView => {
  return tile.item.widget.type === WidgetType.SmartView;
};

export const isTileObjectFilter = (tile: TileObject): tile is TileObjectFilter => {
  return tile.item.widget.type === WidgetType.Filter;
};

export const isSmartViewWidget = (widget: Widgets): widget is SmartViewWidget => {
  return widget.type === WidgetType.SmartView;
};

export const isFilterWidget = (widget: Widgets): widget is FilterWidget => {
  return widget.type === WidgetType.Filter;
};
